<main class="dashboard-container">
  <!-- Header Section - Style Befret épuré -->
  <div class="dashboard-header">
    <div class="container py-4">
      <div class="row align-items-center">
        <div class="col-lg-8">
          <h1 class="page-title">
            <i class="fas fa-chart-line me-3"></i>
            {{ "DASHBOARD.TITLE" | productionTranslate }}
          </h1>
          <p class="page-subtitle" *ngIf="userProfile">
            {{ "DASHBOARD.WELCOME" | productionTranslate }}, {{userProfile?.fullname || 'User'}}
          </p>
        </div>
        <div class="col-lg-4 text-end">
          <button mat-raised-button color="primary" class="befret-button me-2" (click)="refreshData()">
            <mat-icon>refresh</mat-icon>
            {{ "DASHBOARD.ACTIONS.REFRESH" | productionTranslate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <section class="pt40 pb40">
    <div class="container">

      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-container">
        <mat-spinner diameter="50"></mat-spinner>
        <p class="mt-3">{{ "DASHBOARD.LOADING" | productionTranslate }}</p>
      </div>

      <!-- Error State -->
      <div *ngIf="errorMessage && !isLoading" class="error-container">
        <mat-icon color="warn">error</mat-icon>
        <p>{{errorMessage}}</p>
        <button mat-raised-button (click)="refreshData()">{{ "DASHBOARD.ACTIONS.RETRY" | productionTranslate }}</button>
      </div>

      <!-- Dashboard Content -->
      <div *ngIf="!isLoading && !errorMessage && stats">

        <!-- Statistics Cards (Row 1) -->
        <div class="row mb-4">
          <div class="col-md-3 mb-3">
            <mat-card class="stat-card stat-card-total">
              <mat-card-content>
                <div class="stat-icon">
                  <mat-icon>inventory_2</mat-icon>
                </div>
                <div class="stat-info">
                  <h3>{{stats.totalShipments}}</h3>
                  <p>{{ "DASHBOARD.STATS.TOTAL" | productionTranslate }}</p>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

          <div class="col-md-3 mb-3">
            <mat-card class="stat-card stat-card-transit">
              <mat-card-content>
                <div class="stat-icon">
                  <mat-icon>local_shipping</mat-icon>
                </div>
                <div class="stat-info">
                  <h3>{{sentCount}}</h3>
                  <p>{{ "DASHBOARD.STATS.IN_TRANSIT" | productionTranslate }}</p>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

          <div class="col-md-3 mb-3">
            <mat-card class="stat-card stat-card-delivered">
              <mat-card-content>
                <div class="stat-icon">
                  <mat-icon>check_circle</mat-icon>
                </div>
                <div class="stat-info">
                  <h3>{{deliveredCount}}</h3>
                  <p>{{ "DASHBOARD.STATS.DELIVERED" | productionTranslate }}</p>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

          <div class="col-md-3 mb-3">
            <mat-card class="stat-card stat-card-revenue">
              <mat-card-content>
                <div class="stat-icon">
                  <mat-icon>euro</mat-icon>
                </div>
                <div class="stat-info">
                  <h3>€{{stats.totalRevenue.toFixed(0)}}</h3>
                  <p>{{ "DASHBOARD.STATS.REVENUE" | productionTranslate }}</p>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>

        <!-- Quick Actions Section -->
        <div class="row mb-4">
          <div class="col-lg-12">
            <mat-card class="actions-card">
              <mat-card-header>
                <mat-card-title>
                  <mat-icon>bolt</mat-icon>
                  {{ "DASHBOARD.QUICK_ACTIONS.TITLE" | productionTranslate }}
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <!-- Primary Actions -->
                <div class="actions-section mb-4">
                  <h6 class="section-label">{{ "DASHBOARD.TITLES.GENERAL" | productionTranslate }}</h6>
                  <div class="row g-3">
                    <div class="col-md-6" *ngFor="let action of quickActions.slice(0, 2)">
                      <button mat-raised-button
                              class="action-button action-primary w-100"
                              (click)="navigateWithAction(action)">
                        <mat-icon>{{action.icon}}</mat-icon>
                        <span>{{action.labelKey | productionTranslate}}</span>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Belgium Status Actions -->
                <div class="actions-section mb-4" *ngIf="isManager()">
                  <h6 class="section-label">{{ "DASHBOARD.TITLES.BELGIUM" | productionTranslate }}</h6>
                  <div class="row g-3">
                    <div class="col-md-6">
                      <button mat-raised-button
                              class="action-button action-status w-100"
                              (click)="navigateToStatus('order_confirmed')">
                        <mat-icon>schedule</mat-icon>
                        <span>{{ "DASHBOARD.ACTIONS.RECEPTION_BEL" | productionTranslate }}</span>
                        <span class="badge badge-warning" *ngIf="pendingCount > 0">{{pendingCount}}</span>
                      </button>
                    </div>
                    <div class="col-md-6">
                      <button mat-raised-button
                              class="action-button action-status w-100"
                              (click)="navigateToStatus('warehouse')">
                        <mat-icon>move_to_inbox</mat-icon>
                        <span>{{ "DASHBOARD.ACTIONS.SEND_DRC" | productionTranslate }}</span>
                        <span class="badge badge-info" *ngIf="receivedCount > 0">{{receivedCount}}</span>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- DRC Status Actions -->
                <div class="actions-section mb-4" *ngIf="isManager()">
                  <h6 class="section-label">{{ "DASHBOARD.TITLES.DRC" | productionTranslate }}</h6>
                  <div class="row g-3">
                    <div class="col-md-6">
                      <button mat-raised-button
                              class="action-button action-status w-100"
                              (click)="navigateToStatus('befret_transit')">
                        <mat-icon>local_shipping</mat-icon>
                        <span>{{ "DASHBOARD.ACTIONS.RECEPTION_DRC" | productionTranslate }}</span>
                        <span class="badge badge-primary" *ngIf="sentCount > 0">{{sentCount}}</span>
                      </button>
                    </div>
                    <div class="col-md-6">
                      <button mat-raised-button
                              class="action-button action-status w-100"
                              (click)="navigateToStatus('congo_distribution')">
                        <mat-icon>inventory</mat-icon>
                        <span>{{ "DASHBOARD.ACTIONS.DELIVERIES" | productionTranslate }}</span>
                        <span class="badge badge-success" *ngIf="arrivedCount > 0">{{arrivedCount}}</span>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Management Actions -->
                <div class="actions-section" *ngIf="isManager()">
                  <h6 class="section-label">{{ "DASHBOARD.TITLES.MANAGEMENT" | productionTranslate }}</h6>
                  <div class="row g-3">
                    <div class="col-md-6" *ngFor="let action of quickActions.slice(6, 8)">
                      <button mat-raised-button
                              class="action-button action-secondary w-100"
                              (click)="navigateWithAction(action)">
                        <mat-icon>{{action.icon}}</mat-icon>
                        <span>{{action.labelKey | productionTranslate}}</span>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Envoi Assisté Section -->
                <div class="actions-section mt-4" *ngIf="isManager()">
                  <h6 class="section-label">📞 {{ "DASHBOARD.TITLES.ASSISTED_SHIPPING" | productionTranslate }}</h6>
                  <div class="row g-3">
                    <div class="col-md-12">
                      <button mat-raised-button
                              class="action-button action-assisted w-100"
                              [routerLink]="['/new-shipment']"
                              [queryParams]="{mode: 'assisted'}">
                        <mat-icon>headset_mic</mat-icon>
                        <span>{{ "DASHBOARD.ACTIONS.ASSISTED_SHIPPING" | productionTranslate }}</span>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Virtual Mailbox Section -->
                <div class="actions-section mt-4" *ngIf="isManager()">
                  <h6 class="section-label">📦 Virtual Mailbox</h6>
                  <div class="row g-3">
                    <div class="col-md-12">
                      <button mat-raised-button
                              class="action-button action-vm w-100"
                              routerLink="/vm/backoffice">
                        <mat-icon>markunread_mailbox</mat-icon>
                        <span>{{ "DASHBOARD.ACTIONS.VIRTUAL_MAILBOX" | productionTranslate }}</span>
                      </button>
                    </div>
                  </div>
                </div>

              </mat-card-content>
            </mat-card>
          </div>
        </div>

        <!-- Charts Row -->
        <div class="row mb-4">
          <!-- Country Revenue Chart -->
          <div class="col-lg-6 mb-3">
            <mat-card class="chart-card">
              <mat-card-header>
                <mat-card-title>
                  <mat-icon>public</mat-icon>
                  {{ "DASHBOARD.CHARTS.REVENUE_BY_COUNTRY" | productionTranslate }}
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div class="country-revenue-chart">
                  <table class="country-table">
                    <thead>
                      <tr>
                        <th>{{ "DASHBOARD.COLUMNS.PAYMENTS" | productionTranslate }}</th>
                        <th>{{ "DASHBOARD.COLUMNS.COUNTRY" | productionTranslate }}</th>
                        <th class="text-end">{{ "DASHBOARD.COLUMNS.ORDERS" | productionTranslate }}</th>
                        <th class="text-end">{{ "DASHBOARD.COLUMNS.PERCENTAGE" | productionTranslate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let country of countrySummary; let i = index"
                          class="country-row"
                          (click)="navigateToCountry(country.countryCode)"
                          [class.clickable]="isManager()">
                        <td class="amount-cell">{{formatCurrency(country.revenue)}}</td>
                        <td class="country-cell">
                          <span class="country-name">{{country.countryName}}</span>
                          <div class="country-bar"
                               [ngClass]="getCountryBarColorClass(i)"
                               [style.width]="country.percentage + '%'">
                          </div>
                        </td>
                        <td class="text-end count-cell">{{country.shipmentCount}}</td>
                        <td class="text-end percentage-cell">
                          <span [ngClass]="getStatusColorClass(i)">{{formatPercentage(country.percentage)}}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

          <!-- Monthly Revenue Chart -->
          <div class="col-lg-6 mb-3">
            <mat-card class="chart-card">
              <mat-card-header>
                <mat-card-title>
                  <mat-icon>show_chart</mat-icon>
                  {{ "DASHBOARD.CHARTS.MONTHLY_REVENUE" | productionTranslate }}
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div class="monthly-chart">
                  <div class="chart-container">
                    <!-- Scale markers -->
                    <div class="scale-markers">
                      <div class="scale-marker" *ngFor="let marker of scaleMarkers"
                           [style.left]="marker.position + '%'">
                        <div class="marker-line"></div>
                        <span class="marker-value">€{{marker.value}}</span>
                      </div>
                    </div>

                    <!-- Bars -->
                    <div class="monthly-bars">
                      <div class="monthly-bar-row" *ngFor="let month of monthlyData; let i = index">
                        <div class="month-label">{{month.month}}</div>
                        <div class="bar-container">
                          <div class="monthly-bar"
                               [ngStyle]="{
                                 'background': getBarGradient(i, monthlyData.length),
                                 '--final-width': month.percentage + '%'
                               }"
                               [class.empty-bar]="month.revenue === 0"
                               [style.animation-delay]="'0s, ' + (0.5 + i * 0.1) + 's'">
                            <span class="bar-value" [style.animation-delay]="(1.3 + i * 0.1) + 's'">
                              €{{month.revenue.toFixed(0)}}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>

      </div>

    </div>
  </section>
</main>
